import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { authSlice } from './slices/authSlice';
import { apiSlice } from './api/apiSlice';
import { modalSlice } from './slices/modalSlice';
import userReducer from './slices/userSlice';
import walletReducer from './slices/walletSlice';
import notificationReducer from './slices/notificationSlice';
import bannerReducer from './slices/bannerSlice';
import stakeReducer from './slices/stakeSlice';
import betReducer from './slices/betSlice';
import fixtureReducer from './slices/fixtureSlice';
import oneClickBetReducer from './slices/oneClickBetSlice';
import casinoGameplayReducer from './slices/casinoGameplaySlice';

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    api: apiSlice.reducer,
    modal: modalSlice.reducer,
    user: userReducer,
    wallet: walletReducer,
    notification: notificationReducer,
    banner: bannerReducer,
    stake: stakeReducer,
    bet: betReducer,
    fixture: fixtureReducer,
    oneClickBet: oneClickBetReducer,
    casinoGameplay: casinoGameplayReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(apiSlice.middleware),
  devTools: import.meta.env.DEV,
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export action creators
export const { setToken, logout } = authSlice.actions;
